define(
	'toolkit/b-captcha/b-captcha',
	[
		'toolkit/b-toolkit/b-toolkit',
		'toolkit/b-input/b-input'
	], function(toolkit) {
	'use strict';

	return toolkit.create( 'b-captcha', {

		refresh: function (event) {
			var $img = this.$el.find('.js-captcha-img'),
				uri = $img.attr('src'),
				sid = (new Date()).getTime();

			$img.attr('src', uri.replace(/\?(.*)/, '?' + sid));

			this.$input = this.$el.find('[data-bem="b-input"]');
			this.$input.val('');
			this.emit('reload');

			if(event) {
				event.preventDefault();
			}
		},

		deferredInit: true,

		init: function () {
			this._initElems();
		},

		onRender: function () {
			this._initElems();
		},

		_initElems: function () {
			this.$el
				.bind('refresh', this.refresh.bind(this))
				.delegate('.js-captcha-reload', 'tap', this._onCaptchaReloadTap.bind(this));

			// нужен для режима без рендеринга когда есть уже html готовая
			this.$input = this.$el.find('[data-bem="b-input"]');

			// Работает только для элементов которые рендерятся с помощью шаблона
			// и больше не перерендериваются
			this.input = this.$input.getBlock();
			this.input.on('change', function(){
				this.emit('change');
			}.bind(this));
		},

		/**
		 * Обработка клика по кнопке "не вижу кода"
		 *
		 * @private
		 */
		_onCaptchaReloadTap: function(event) {
			$.event.trigger('ui-abstract-action', {chain: ['b-captha', 'click-on-captcha-reload']});
			this.refresh(event);
			this.hideError();
		},

		/**
		 * Возращает текущее введеное значение
		 *
		 * @return {string}
		 */
		getValue: function() {
			return this.$input.val();
		},

		validate: function (validator) {
			return validator(this.$input, this.$input.val());
		},

		showError: function(type) {
			var err = this._getError(type);

			if(err) {
				this.$('.b-captcha__error-msg').html(err.text || '');
			}

			this.toggleMod('invalid', true);
		},

		/**
		 * Передаем модификаторы дальше дочерним блокам
		 *
		 * @param mod
		 * @param state
		 */
		toggleMod: function(mod, state) {
			toolkit['b-toolkit'].fn.toggleMod.call(this, mod, state);

			this.input.toggleMod(mod, state);
		},

		hideError: function() {
			this.$('.b-captcha__error-msg').html('');
			this.toggleMod('invalid', false);
		},

		/**
		 * Поиск ошибки по ее типу
		 *
		 * @param {string} type
		 * @returns {object}
		 * @private
		 */
		_getError: function(type) {
			var result = null;

			var errors = this.getData().errors || [];

			errors.forEach(function(item){
				if(result) return;
				if(item.type === type) {
					result = item;
				}
			});

			return result;
		}
	});

});
